// packages/web/src/lib/tap.ts — R4 (Actionable Everywhere, WS2): the one tiny
// helper that turns any non-<button> element (a stat cell, a rollup row, a
// doorway tile) into an accessible tap target. Every surfaced item is a LIVE
// HANDLE — a read-only <div> that represents records gets role="button", a tab
// stop, and Enter/Space activation so the mouse and the keyboard reach the same
// destination. Passing no handler returns an empty prop bag, so a caller can
// spread `tapProps(maybeUndefined)` unconditionally and a non-resolvable item
// simply stays inert (never crashes, never a dead role="button").
export function tapProps(onClick?: () => void) {
  if (!onClick) return {} as const;
  return {
    role: 'button' as const,
    tabIndex: 0,
    onClick,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    },
  };
}
